import { RestaurantMainInfo, RestaurantSubInfo } from '~/features/info/RestaurantInfo'
import { RestaurantInfoAccordion } from '~/features/info/RestaurantInfoAccordion'
import type { Props } from '../GuideRestaurantInfo'
import { mainShowTypes, subShowTypes } from '../GuideRestaurantInfo'

export function GuideRestaurantInfo({ restaurant, viewType = 'guide', className }: Props) {
  return (
    <RestaurantInfoAccordion
      mainContent={
        <RestaurantMainInfo restaurant={restaurant} showTypes={mainShowTypes(viewType)} />
      }
      subContent={<RestaurantSubInfo restaurant={restaurant} showTypes={subShowTypes(viewType)} />}
      isGuide={viewType === 'guide'}
      isPlanModal={viewType === 'planModal'}
      className={className}
    />
  )
}
